import { Component, OnInit, DoCheck, Output, EventEmitter, ViewChild, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NavigationExtras, Router } from '@angular/router';
import { DxSelectBoxComponent } from 'devextreme-angular';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import { ToastService } from 'ng-uikit-pro-standard';
import { AppConfigService } from 'src/app/app-config.service.service';
import { MarketServiceInterface, UnitOrDriverInterface } from 'src/app/models/models.interface';
import { CreateUpdateSalesProjectComponent } from 'src/app/pages/sales-management/sales-project/create-update-sales-project/create-update-sales-project.component';
import { ContactService } from 'src/app/services/contact.service';
import { SharedDatagridModule } from 'src/app/shared/shared-datagrid/shared-datagrid.module';
import { MapInformationService } from '../../../../../services/map-information.service'

@Component({
  selector: 'new-service-work-order',
  templateUrl: './new-service-work-order.component.html',
  styleUrls: ['./new-service-work-order.component.scss']
})
export class NewServicesOrderComponent implements OnInit {
  plusSiteButton: any;
  plusContactButton: any;
  plusResponsibleButton: any;
  plusResourcesButton:any;

  @Output() cloeModal1 = new EventEmitter();
  @Output() reloadService = new EventEmitter();
  @Input() VieneDe;
  @Input() projectid;
  @Input() projectName;
  public ValueDate: Date = new Date();
  public ValueDatesscheduledate= new Date();
  public ValueDatesEstimatedHours: Date;
  private auxDate: Date;
  popupSWOClient = false;
  @Output() ValueChange: EventEmitter<Date>;
  customerDataSourceresponsible: any;
  requestDataSource:any;
  request:any
  sitename:any
  siteName:any
  salesProject:any
  responsible:any
  popupServiceSite=false
  popupNewContact = false;
  popupResponsible = false;
  popupResources = false
  idNewSWO:any
  popupSalesProject = false;
  nuevaInfo=''
  category = ""
  type = ""
  priority=""
  hoursText: any
  showPopUP:boolean=true


  loadInfo = {
    siteid: [],
    servicetype: [],
    servicecategoryid: [],
    requestedbyid: [],
    requestdate: [],
    customerpo: "",
    userid: [],
    resources: [],
    // subcontractorid: [],
    serviceestimatedhours: [],
    scheduledate: [],
    callahead: [],
    serviceconfirmed: [],
    projectid: [],
    priorityid: [],
    reasonforservice: [],
  };


  newSWO = new FormGroup({
    siteid: new FormControl({ value: '', disabled: false }, [Validators.required]),
    servicetype: new FormControl({ value: '', disabled: false }, [Validators.required]),
    servicecategoryid: new FormControl({ value: '', disabled: false }, [Validators.required]),
    requestedbyid: new FormControl({ value: '', disabled: false }, [Validators.required]),
    requestdate: new FormControl(new Date()),
    customerpo: new FormControl({ value: '', disabled: false }, []),
    servicedoneby: new FormControl({ value: '', disabled: false }, [Validators.required]),
    resources: new FormControl({ value: '', disabled: false }, []),
    // subcontractorid: new FormControl(''),
    serviceestimatedhours: new FormControl(''),
    scheduledate: new FormControl({ value: new Date(), disabled: false }, [Validators.required]),
    callahead: new FormControl(false),
    serviceconfirmed: new FormControl(false),
    projectid: new FormControl({ value: '', disabled: false }, []),
    priorityid: new FormControl({ value: '', disabled: false }, [Validators.required]),
    reasonforservice: new FormControl(''),
    Notify_Technician: new FormControl(false),
    serviceid:new FormControl({ value: 0, disabled: false }, []),
  });

  cancelButton:any
  saveButton:any
  saveNewButton:any
  saveEditButton:any

  dateFormat:any
  ResponsibleDataSource:any
  recursos:any[]=[]
  siteDataSource:any
  projectDataSource:any

  @ViewChild("newSiteSelect", { static: false }) newSiteSelect: DxSelectBoxComponent;
  @ViewChild("newProjectSelect", { static: false }) newProjectSelect: DxSelectBoxComponent;
  @ViewChild("newRequestSelect", { static: false }) newRequestSelect: DxSelectBoxComponent;
  @ViewChild("newResponsibleSelect", { static: false }) newResponsibleSelect: DxSelectBoxComponent;

  /**new sales project */
  cancelButtonNewSales: any;
  saveButtonNewSales: any;
  saveNewButtonNewSales: any;
  saveEditButtonNewSales: any;
  @ViewChild('componentSales', { static: false }) componentSales: CreateUpdateSalesProjectComponent;
  popupCreateSalesProject:boolean=false
  plusSalesProjectButton: any;

  constructor(
    public MapInformationService:MapInformationService,
    private toast: ToastService,
    private contactService: ContactService,
    private router: Router,
    private appConfigService: AppConfigService
    // private datagrid: SharedDatagridModule,
  ) {
    // this.auxDate = this.ValueDate = new Date();
    // this.ValueChange = new EventEmitter();
    this.dateFormat = this.appConfigService.dateFormat

    this.plusSiteButton = {
      icon:"plus",
      type: "button",
      onClick: () => {
          this.popupServiceSite = true;
      }
    };

    this.plusContactButton = {
      icon:"plus",
      type: "button",
      onClick: () => {
          this.popupNewContact = true;
      }
    };

    this.plusResponsibleButton = {
      icon:"plus",
      type: "button",
      onClick: () => {
          this.popupResponsible = true
      }
    };

    this.plusResourcesButton = {
      icon:"plus",
      type: "button",
      onClick: () => {
          this.popupResources = true
      }
    };

        this.cancelButton = {
          text: 'Cancel',
          elementAttr: {
            id:'bton-gray'
          },
          onClick: () => {
            this.closeModalOutput()
          },
        };


      this.saveButton = {
        text: 'Save',
        icon: 'check',
        elementAttr: {
          id:'bton-green'
        },
        onClick: () => {
          // this.type = 1;
          // this.componentSales.updateSalesProject(1);
          this.sendInfo('')
        },
      };

      this.saveNewButton = {
        text: 'Save & New',
        elementAttr: {
          id:'bton-gray-outline'
        },
        onClick: () => {
          // this.type = 2;
          // this.componentSales.updateSalesProject(2);
          this.sendInfo('newInfo')
        }
      };

      this.saveEditButton = {
        text: 'Save & Edit',
        elementAttr: {
          id:'bton-gray-outline'
        },
        onClick: () => {
          // this.type = 2;
          // this.componentSales.updateSalesProject(2);
          this.sendInfo('edit');
        }
      };

      this.plusSalesProjectButton = {
        icon: "plus",
        type: "button",
        hint:"Create new Sales project",
        onClick: () => {
          this.popupCreateSalesProject = true
        } 
      };

      this.cancelButtonNewSales = {
        text: 'Cancel',
        elementAttr: {
          id: 'bton-gray'
        },
        onClick: () => {
          this.componentSales.ngOnInit();
          this.popupCreateSalesProject = false;
        },
      };

      this.saveButtonNewSales = {
        text: 'Save',
        icon: 'check',
        elementAttr: {
          id: 'bton-green'
        },
        onClick: () => {
          this.componentSales.updateSalesProject(1);
        },
      };
  }

  ngOnInit(): void {
    this.GetAllInfo()
  }

  GetAllInfo(){
    this.loadInfo = {
      siteid: [],
      servicetype: [],
      servicecategoryid: [],
      requestedbyid: [],
      requestdate: [],
      customerpo: "",
      userid: [],
      resources: [],
      serviceestimatedhours: [],
      scheduledate: [],
      callahead: [],
      serviceconfirmed: [],
      projectid: [],
      priorityid: [],
      reasonforservice: [],
    };
    // this.MapInformationService.GetAllInfo('Get_ServiceSites').
    //   subscribe(sites=>{
        // this.MapInformationService.GetAllInfo('ServiceTechnician')
        // this.MapInformationService.GetAllInfo('Get_EmployeeListAll')
        // .subscribe(responsible=>{
          this.MapInformationService.GetAllInfoFiltro('Get_DefaultServiceType',localStorage.getItem('customerid'))
          .subscribe(type=>{
            this.MapInformationService.GetAllInfo('GetServicePriorityCE')
            .subscribe(priority=>{
              this.MapInformationService.GetAllInfoFiltro('Get_DefaultServicePriority',localStorage.getItem('customerid'))
              .subscribe(defaultPriority=>{
                this.MapInformationService.GetAllInfoFiltro('Get_DefaultServiceCategory',localStorage.getItem('customerid'))
                .subscribe(category=>{
                  // this.MapInformationService.GetAllInfo('Get_SalesProjectList')
                  // .subscribe(salesProject=>{
                    this.MapInformationService.GetAllInfo('Get_EmployeeListAll')
                    .subscribe(resources=>{
                      console.log('aqui estan los recursos')
                      console.log(resources)
                      console.log('aqui estan los recursos')
                      this.MapInformationService.GetAllInfoFiltro('Get_DefaultServiceHours',localStorage.getItem('customerid'))
                      .subscribe(hours=>{
                        this.MapInformationService.GetAllInfo('Get_ServiceTypes')
                        .subscribe(allCategory=>{
                          this.MapInformationService.GetAllInfo('Get_SerCategory')
                          .subscribe(allTypes=>{

                            this.hoursText = hours[0].Service_Hours
                            this.newSWO.get('serviceestimatedhours').setValue(this.hoursText);
                            if(this.VieneDe == "Service Contract"){
                              this.newSWO.get('projectid').setValue(this.projectid);
                            }

                            allCategory.forEach((element,index) => {
                              if(element.SERVICETYPE != ""){
                                this.loadInfo.servicetype.push(element)
                              }
                              console.log(category)
                              console.log(type)
                              if(element.ID == category[0].ID){
                                this.newSWO.get('servicetype').setValue(element.ID);
                                this.type = element.ID
                              }
                            });
                            console.log(defaultPriority)
                            priority.forEach((element,index) => {
                              if(element.name != ""){
                                this.loadInfo.priorityid.push(element)
                              }
                              if(element.ID == defaultPriority[0].ID){
                                this.newSWO.get('priorityid').setValue(element.ID);
                                this.priority = element.ID
                              }
                            });
                            allTypes.forEach((element,index) => {
                              if(element.NAME != ""){
                                this.loadInfo.servicecategoryid.push(element)
                              }
                              if(element.ID == type[0].ID){
                                this.newSWO.get('servicecategoryid').setValue(element.ID);
                                this.category = element.ID
                              }
                            });
                            // salesProject.forEach(element => {
                            //   if(element.name != ""){
                            //     this.loadInfo.projectid.push(element)
                            //   }
                            // });
                            // sites.forEach(element => {
                            //   if(element.name != ""){
                            //     this.loadInfo.siteid.push(element)
                            //   }
                            // });
                            resources.forEach(element => {
                              if(element.CONTACTNAME != ""){
                                this.loadInfo.userid.push(element)
                              }
                              if(localStorage.getItem('customerid') == element.ID){
                                this.newSWO.get('servicedoneby').setValue(element.ID);
                                this.responsible = element.CONTACTNAME
                                this.newResponsibleSelect.placeholder = element.CONTACTNAME
                              }
                            });
                            resources.forEach(element => {
                              if(element.FIRSTNAME != ""){
                                this.loadInfo.resources.push(element)
                              }
                            });

                            let mythis = this;
                            this.requestDataSource = new CustomStore({
                              key: "ID",
                              useDefaultSearch: false,
                              load: function (loadOptions: any) {
                                if (loadOptions.searchValue == "" || loadOptions.searchValue == undefined) {
                                  loadOptions.searchValue = " "
                                } else {
                                  loadOptions.searchValue = loadOptions.searchValue
                                }
                                return mythis.MapInformationService.GetAllInfoDinamico("Get_ContactsByName",loadOptions.searchValue)
                                  .toPromise()
                                  .then((data: any) => {
                                    console.log(data);
                                    return data;
                                  })
                                  .catch(error => { throw 'Data Loading Error' });
                              }
                            });
                          })
                        })
                      })
                    })
                  // })
                })
              })
            })
          })

        // })
    // })

    let mythis = this;
    this.siteDataSource = new CustomStore({
      key: "ID",
      load: function (loadOptions: any) {
        if (loadOptions.searchValue == "" || loadOptions.searchValue == undefined) {
          loadOptions.searchValue = " "
        } else {
          loadOptions.searchValue = loadOptions.searchValue
        }
        return mythis.MapInformationService.GetAllInfoDinamico('Get_ServiceSites',loadOptions.searchValue)
          .toPromise()
          .then((data: any) => {
            return data;
          })
          .catch(error => { throw 'Data Loading Error' });
      }
    });

    this.projectDataSource = new CustomStore({
      key: "ID",
      load: function (loadOptions: any) {
        if (loadOptions.searchValue == "" || loadOptions.searchValue == undefined) {
          loadOptions.searchValue = " "
        } else {
          loadOptions.searchValue = loadOptions.searchValue
        }
        return mythis.MapInformationService.GetAllInfoDinamico('Get_SalesProjectList',loadOptions.searchValue)
          .toPromise()
          .then((data: any) => {
            console.log(data)
            return data;
          })
          .catch(error => { throw 'Data Loading Error' });
      }
    });

    this.ResponsibleDataSource = new CustomStore({
      key: "ID",
      load: function (loadOptions: any) {
        // if (loadOptions.searchValue == "" || loadOptions.searchValue == undefined) {
        //   loadOptions.searchValue = "cond"
        // } else {
        //   loadOptions.searchValue = loadOptions.searchValue
        // }
        return mythis.MapInformationService.GetAllInfo('Get_EmployeeListAll')
          .toPromise()
          .then((data: any) => {
            console.log(data)
            return data;
          })
          .catch(error => { throw 'Data Loading Error' });
        }
      });
  }
  

  updateForm(item,tipo_select) {

    switch(tipo_select){
      case 'Responsible':
        if (item.selectedItem && item.selectedItem.ID) {
          this.newSWO.get('servicedoneby').setValue(item.selectedItem.ID);
          this.responsible = item.selectedItem.CONTACTNAME
        }
      break
      case 'Site_Name':
        if (item.selectedItem && item.selectedItem.ID) {
          this.newSWO.get('siteid').setValue(item.selectedItem.ID);
          this.sitename = item.selectedItem.name
          this.siteName = item.selectedItem.name
        }
      break
      case 'Sales_Project':
        if (item.selectedItem && item.selectedItem.ID) {
          this.newSWO.get('projectid').setValue(item.selectedItem.ID);
          this.salesProject = item.selectedItem.Description
        }
      break
    }
  }

  handleAddressChange(res){
    this.newSWO.get('lon').setValue(res.geometry.location.lng());
    this.newSWO.get('lat').setValue(res.geometry.location.lat());
  }

  sendInfo(newInfo){
    this.nuevaInfo = '';
    if(newInfo == 'newInfo'){
      this.nuevaInfo = newInfo
    } else if (newInfo == 'edit'){
      this.nuevaInfo = newInfo
    }

    // if(this.newSWO.value.projectid == ''){
      this.popupSalesProject = true
    // }
  }

  updateOwener(item) {
    if (item.selectedItem && item.selectedItem.ID) {
      this.newSWO.get('requestedbyid').setValue(item.selectedItem.ID);
      this.request = item.selectedItem.ContaNameID
      // this.newRequestSelect.placeholder = item.selectedItem.First + ' ' + item.selectedItem.Last;
    }
  }

  close(){
    console.log("close")
  }

  resultNewSite($event){
    console.log($event)
    this.popupServiceSite = false
    this.newSWO.get('siteid').setValue($event.id);
    this.sitename = $event.name
    this.newSiteSelect.placeholder = $event.name
  }

  closeModalOutput() {
    this.newSiteSelect.placeholder = '';
    console.log(this.VieneDe)
    if(this.VieneDe != "Service Contract"){
      this.newProjectSelect.placeholder = '';
    }
    this.newRequestSelect.placeholder = '';
    this.request = ''
    this.sitename = ''
    this.salesProject = ''
    this.responsible = ''
    this.newSWO.reset()
    this.cloeModal1.emit(true);
    this.GetAllInfo();
    this.newSWO.get('scheduledate').setValue(new Date);
    this.newSWO.get('requestdate').setValue(new Date);
    this.ValueDate = new Date;
    this.ValueDatesscheduledate = new Date;
  }

  convertFecha(fecha){
    let date = ("0" + fecha.getDate()).slice(-2);

    // current month
    let month = ("0" + (fecha.getMonth() + 1)).slice(-2);

    // current year
    let year = fecha.getFullYear();

    // current hours
    let hours = fecha.getHours();

    // current minutes
    let minutes = fecha.getMinutes();

    // current seconds
    let seconds = fecha.getSeconds();
    console.log(seconds)

    // prints date & time in YYYY-MM-DD HH:MM:SS format
    const fecha_final = year + month + date + " " + hours + ":" + minutes + ":" + "00";
    return fecha_final
  }

  // openModalNewContact() {
  //   console.log("aqui")
  //   this.popupNewContact = true;
  // }

  onsave(e){
    console.log(e);
    this.newSWO.get('requestedbyid').setValue(e.id);
    this.request = e.First + ' ' + e.Last;
    this.newRequestSelect.placeholder = this.request;
  }

  // SaveInfo(aceptar){
  //   console.log(this.newSWO.value)
  //   this.SendEmail(this.newSWO.value.resources) 
  // }

  SaveInfo(aceptar){

    this.request = ''
    this.sitename = ''
    this.salesProject = ''
    this.responsible = ''
    this.recursos = []
    let recursos_select = []

    if(aceptar == 'Yes'){
      if(this.newSWO.value.callahead){this.newSWO.value.callahead = 1
      }else{this.newSWO.value.callahead = 0 }

      if(this.newSWO.value.Notify_Technician){this.newSWO.value.Notify_Technician = 1}
      else {this.newSWO.value.Notify_Technician = 0 }

      if(this.newSWO.value.serviceconfirmed){this.newSWO.value.serviceconfirmed = 1}
      else {this.newSWO.value.serviceconfirmed = 0 }

      let resourcesString = "" 
      if(this.newSWO.value.resources.length != 0){
        recursos_select = this.newSWO.value.resources
        this.newSWO.value.resources.forEach((element,index) => {
          // resourcesString.push(element.toString())
          if(index == 0){
            resourcesString += element.toString()
          } else {
            resourcesString += ","+element.toString()
          }
        });

        this.newSWO.value.resources = resourcesString;
      } else {
        this.newSWO.value.resources = resourcesString;
      }

      this.newSWO.value.serviceid = 0

      const scheduledate = this.convertFecha(this.newSWO.value.scheduledate)
      const requestdate = this.convertFecha(this.newSWO.value.requestdate)
      // const serviceestimatedhours = this.convertFecha(this.newSWO.value.serviceestimatedhours)

      this.newSWO.value.scheduledate = scheduledate
      this.newSWO.value.requestdate = requestdate
      // this.newSWO.value.serviceestimatedhours = serviceestimatedhours

      let formValue;
      formValue = this.newSWO.value;
      formValue.method ="Insert_ServiceCU"
      this.popupSalesProject = false
      console.log('aqui estan los site')
      console.log(this.siteDataSource)
      console.log('aqui estan los site')
      this.MapInformationService.SaveInfoSites({method:"Get_ClientSettingsByName",name:"DefaultServiceStatus"})
      .subscribe(information=>{
        console.log('aqui')
        console.log(information)
        formValue.statusid= Number(information[0].VALUE)
        console.log('este es el formValue v')
        console.log(formValue)
        this.MapInformationService.InsertSWO(formValue)
        .subscribe(resp=>{
          if(this.newSWO.value.Notify_Technician == 1){
            let SWO_id = resp[0].ResultID
            const subject =  "Service #"+SWO_id+" " + this.siteName
            let lista_email = []
            let recursos_all = this.loadInfo.resources
            recursos_select.forEach(e_1 => {
              recursos_all.forEach(e_2 => {
                if(e_1 === e_2.ID){
                  lista_email.push(e_2.EMAIL)
                }
              })
            })
            console.log(lista_email)
            let lista_email_final = lista_email.toString()
            console.log(lista_email_final)
            this.MapInformationService.NotifyTechnician(SWO_id, lista_email_final, subject)
            .subscribe(res=>{
              console.log('alooooo')
              console.log(res)
              this.toast.success("An Email has been sent to the Technician.")
            })
          }
          console.log(this.nuevaInfo)
          if(this.nuevaInfo == 'newInfo'){
            console.log('aqui es el newInfo')
            console.log(resp)
            this.toast.success('Service Work Order Created Successfully');
            this.newSWO.reset()
            this.idNewSWO = resp.ResultID
            this.reloadService.emit()
            this.GetAllInfo();
            this.newSWO.get('scheduledate').setValue(new Date);
            this.newSWO.get('requestdate').setValue(new Date);
            this.ValueDate = new Date;
            this.ValueDatesscheduledate = new Date;
            // this.datagrid.reloadComponent();
  
            // this.ReloadSites();
          } else if (this.nuevaInfo == ''){
            console.log(resp)
            this.toast.success('Service Work Order Created Successfully');
            this.newSWO.reset()
            this.cloeModal1.emit(true);
            this.reloadService.emit()
            this.idNewSWO = resp.ResultID
            this.GetAllInfo();
            this.newSWO.get('scheduledate').setValue(new Date);
            this.newSWO.get('requestdate').setValue(new Date);
            this.ValueDate = new Date;
            this.ValueDatesscheduledate = new Date;
            // this.datagrid.reloadComponent();
            // this.ReloadSites();
          } else if(this.nuevaInfo == 'edit'){
            console.log(resp)
            this.idNewSWO = resp[0].ResultID
            this.newSWO.value.serviceid = resp[0].ResultID
            localStorage.removeItem('newSwoEdit')
            localStorage.setItem('newSwoEdit',resp[0].ResultID)
            this.toast.success('Service Work Order Created Successfully');
            this.newSWO.reset()
            this.cloeModal1.emit(true);
            this.reloadService.emit()
  
            let navigationExtras: NavigationExtras = {
              state: {
                  id_user:"Hola"
              }
            };
            this.router.navigate(['/swo/editSWON'], navigationExtras);
  
            // this.GetAllInfo();
            // this.newSWO.get('scheduledate').setValue(new Date);
            // this.newSWO.get('requestdate').setValue(new Date);
            // this.ValueDate = new Date;
            // this.ValueDatesscheduledate = new Date;
          }
          this.newSiteSelect.placeholder = '';
          if(this.VieneDe != "Service Contract"){
            this.newProjectSelect.placeholder = '';
          }
          this.newRequestSelect.placeholder = '';
        }, error=> {
          console.log(error)
        })
      })
    } else if('No'){
      if(this.newSWO.value.callahead){this.newSWO.value.callahead = 1
      }else{this.newSWO.value.callahead = 0 }

      if(this.newSWO.value.Notify_Technician){this.newSWO.value.Notify_Technician = 1}
      else {this.newSWO.value.Notify_Technician = 0 }

      if(this.newSWO.value.serviceconfirmed){this.newSWO.value.serviceconfirmed = 1}
      else {this.newSWO.value.serviceconfirmed = 0 }

      let resourcesString = ""
      if(this.newSWO.value.resources.length != 0){
        this.newSWO.value.resources.forEach((element,index) => {
          // resourcesString.push(element.toString())
          if(index == 0){
            resourcesString += element.toString()
          } else {
            resourcesString += ","+element.toString()
          }
        });

        this.newSWO.value.resources = resourcesString;
      } else {
        this.newSWO.value.resources = resourcesString;
      }

      this.newSWO.value.serviceid = 0

      const scheduledate = this.convertFecha(this.newSWO.value.scheduledate)
      const requestdate = this.convertFecha(this.newSWO.value.requestdate)
      // const serviceestimatedhours = this.convertFecha(this.newSWO.value.serviceestimatedhours)

      this.newSWO.value.scheduledate = scheduledate
      this.newSWO.value.requestdate = requestdate
      // this.newSWO.value.serviceestimatedhours = serviceestimatedhours

      let formValue;
      formValue = this.newSWO.value;
      formValue.method ="Insert_ServiceCU"

      this.MapInformationService.SaveInfoSites({method:"Get_ClientSettingsByName",name:"DefaultServiceStatus"})
      .subscribe(information=>{
        console.log(information)
        formValue.statusid= Number(information[0].VALUE)
        this.popupSalesProject = false
        this.MapInformationService.InsertSWO(formValue)
        .subscribe(resp=>{
          if(this.nuevaInfo == 'newInfo'){
            console.log(resp)
            this.toast.success('Service Work Order Created Successfully');
            this.newSWO.reset()
            this.idNewSWO = resp.ResultID
            this.reloadService.emit()
            this.GetAllInfo();
            this.newSWO.get('scheduledate').setValue(new Date);
            this.newSWO.get('requestdate').setValue(new Date);
            this.ValueDate = new Date;
            this.ValueDatesscheduledate = new Date;
            // this.datagrid.reloadComponent();
  
            // this.ReloadSites();
          } else if (this.nuevaInfo == ''){
            console.log(resp)
            this.toast.success('Service Work Order Created Successfully');
            this.newSWO.reset()
            this.cloeModal1.emit(true);
            this.reloadService.emit()
            this.idNewSWO = resp.ResultID
            this.GetAllInfo();
            this.newSWO.get('scheduledate').setValue(new Date);
            this.newSWO.get('requestdate').setValue(new Date);
            this.ValueDate = new Date;
            this.ValueDatesscheduledate = new Date;
            // this.datagrid.reloadComponent();
            // this.ReloadSites();
          } else if(this.nuevaInfo == 'edit'){
            console.log(resp)
            this.idNewSWO = resp[0].ResultID
            this.newSWO.value.serviceid = resp[0].ResultID
            localStorage.removeItem('newSwoEdit')
            localStorage.setItem('newSwoEdit',resp[0].ResultID)
            this.toast.success('Service Work Order Created Successfully');
            this.newSWO.reset()
            this.cloeModal1.emit(true);
            this.reloadService.emit()
  
            let navigationExtras: NavigationExtras = {
              state: {
                  id_user:"Hola"
              }
            };
            this.router.navigate(['/swo/editSWON'], navigationExtras);
  
            // this.GetAllInfo();
            // this.newSWO.get('scheduledate').setValue(new Date);
            // this.newSWO.get('requestdate').setValue(new Date);
            // this.ValueDate = new Date;
            // this.ValueDatesscheduledate = new Date;
          }
          this.newSiteSelect.placeholder = '';
          if(this.VieneDe != "Service Contract"){
            this.newProjectSelect.placeholder = '';
          }
          this.newRequestSelect.placeholder = '';
        }, error=> {
          console.log(error)
        })
      })
    }
  }

  resultNewEmployee($event){
    console.log($event)
    this.MapInformationService.GetAllInfo('Get_EmployeeListAll')
    .subscribe(responsible=>{
      console.log(responsible)
      responsible.forEach(element => {
        if($event.ResultiID == element.ID){
          console.log(element)
          this.newSWO.get('servicedoneby').setValue(element.ID);
          this.responsible = element.CONTACTNAME
          this.newResponsibleSelect.placeholder = element.CONTACTNAME
        }
      });
    })
  }

  resultNewEmployeeResources(item){
    this.loadInfo.resources=[]
    this.MapInformationService.GetAllInfo('Get_EmployeeListAll')
    .subscribe(resources=>{
      resources.forEach(element => {
        if(element.FIRSTNAME != ""){
          this.loadInfo.resources.push(element)
        }
      });
      console.log(item)
      this.recursos.push(item.ResultiID)
    })
  }

  SetSalesProject(event){
    console.log(event)
    this.newSWO.get("projectid").setValue(event.projectid)
    this.newProjectSelect.placeholder = event.name
  }

}
